module.exports = __webpack_public_path__ + "static/Replica-Regular-1d43db606ead297c03f08273249eb84b.woff";